import { render } from "./PersonInfoForm.vue?vue&type=template&id=046602d8&scoped=true"
import script from "./PersonInfoForm.vue?vue&type=script&lang=js"
export * from "./PersonInfoForm.vue?vue&type=script&lang=js"

import "./PersonInfoForm.vue?vue&type=style&index=0&id=046602d8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046602d8"]])

export default __exports__